import { css } from "@emotion/react";
import colors from "assets/css/colors";
import { getBlackedOutCss } from "assets/css/opacity.css";

const borderCss = css`
  border-style: solid;
  border-color: ${colors.strokeGrey};
`;

const baseCellCss = css`
  background-color: ${colors.white};
  padding: 12px 16px;
  box-sizing: border-box;
`;

export const tableWrapperCss = css`
  width: 100%;
  position: relative;
  overflow-x: auto;
`;

export const getRowContentCss = ({ isDataUpdating }) => [
  css`
    width: 100%;
    height: 100%;
  `,
  getBlackedOutCss({ isDataUpdating }),
];

export const trHeaderCss = css`
  margin-bottom: 4px;
`;

const rowWithoutBorderBottom = [
  borderCss,
  css`
    border-width: 1px 0 0;
  `,
];

const rowWithBorderBottom = [
  rowWithoutBorderBottom,
  css`
    &:last-of-type {
      border-bottom-width: 1px;
    }
  `,
];

export function getRowCss(options) {
  const borderBottom = options?.borderBottom ?? true;

  return [
    borderBottom ? rowWithBorderBottom : rowWithoutBorderBottom,
    getBlackedOutCss({ isDataUpdating: options?.isDataUpdating }),
  ];
}

export const headerCellCss = [
  baseCellCss,
  css`
    padding-bottom: 14px;
  `,
];

export const cellCss = [
  baseCellCss,
  borderCss,
  css`
    border-width: 0 1px;
    min-height: 82px;
    word-break: break-word;

    &.sibling + .sibling {
      border-left-width: 0;
    }
  `,
];
